import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SessionState = {
  currentLiveEventCode: string | null;
  fingerprint: string;
  otpCountdownTime: string;
};

const initialState: SessionState = {
  currentLiveEventCode: null,
  fingerprint: '',
  otpCountdownTime: ''
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setCurrentEventCode: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.currentLiveEventCode = action.payload;
    },
    setFingerprint: (state, action: PayloadAction<string>) => ({
      ...state,
      fingerprint: action.payload
    }),
    setOTPCountdownTime: (state, action: PayloadAction<string>) => ({
      ...state,
      otpCountdownTime: action.payload
    }),
    resetCurrentEventCode: state => {
      // eslint-disable-next-line no-param-reassign
      state.currentLiveEventCode = null;
    }
  }
});

export const sessionReducer = sessionSlice.reducer;
export const sessionActions = {
  ...sessionSlice.actions
};
